/**
 * ADIRA Shop by Roast Level
 * Dynamic filtering of coffee products by roast level
 */

(function () {
  'use strict';

  const SECTION_SELECTOR = '.adira-roast';
  const TAB_SELECTOR = '.adira-roast__tab';
  const PRODUCT_SELECTOR = '.adira-roast__product';
  const GRID_SELECTOR = '.adira-roast__products';
  const EMPTY_SELECTOR = '.adira-roast__empty';
  const SCALE_FILL_SELECTOR = '.adira-roast__scale-fill';
  const COUNT_SELECTOR = '.adira-roast__tab-count';

  function init(root) {
    var sections = (root || document).querySelectorAll(SECTION_SELECTOR);
    if (!sections.length) return;

    sections.forEach(function (section) {
      if (section.dataset.adiraRoastInit === '1') return;
      section.dataset.adiraRoastInit = '1';

      const tabs = section.querySelectorAll(TAB_SELECTOR);
      const products = section.querySelectorAll(PRODUCT_SELECTOR);
      const grid = section.querySelector(GRID_SELECTOR);
      const emptyState = section.querySelector(EMPTY_SELECTOR);
      const scaleFill = section.querySelector(SCALE_FILL_SELECTOR);

      // Calculate counts per roast level
      updateCounts(section, products);

      // Initial state: make sure products are visible and empty state is correct
      handleInitialState(products, grid, emptyState);

      // Tab click handler
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          const roast = this.getAttribute('data-roast');
          setActiveTab(tabs, this);
          filterProducts(products, roast, grid, emptyState);
          updateScale(scaleFill, roast);
        });
      });

      // Empty state "View All" button
      if (emptyState) {
        const emptyBtn = emptyState.querySelector('.adira-roast__empty-btn');
        if (emptyBtn) {
          emptyBtn.addEventListener('click', function () {
            const allTab = section.querySelector('[data-roast="all"]');
            if (allTab) allTab.click();
          });
        }
      }

      // Add to cart handlers
      initAddToCart(section);
    });
  }

  /**
   * Handle initial visibility state on page load
   */
  function handleInitialState(products, grid, emptyState) {
    if (products.length === 0) {
      // No products in the DOM at all
      if (emptyState) emptyState.style.display = 'block';
      if (grid) grid.style.display = 'none';
    } else {
      // Products exist, make sure they are visible ("All Roasts" is default)
      products.forEach(function (product) {
        product.classList.remove('hidden', 'hiding');
        product.style.display = '';
      });
      if (emptyState) emptyState.style.display = 'none';
      if (grid) grid.style.display = '';
    }
  }

  /**
   * Update product counts for each roast level tab
   * Products tagged 'all' (no roast tag) count towards every roast tab
   */
  function updateCounts(section, products) {
    const counts = { light: 0, medium: 0, 'medium-dark': 0, dark: 0, all: 0 };

    products.forEach(function (product) {
      const roast = product.getAttribute('data-roast');
      counts.all++;
      if (roast !== 'all' && counts.hasOwnProperty(roast)) {
        counts[roast]++;
      }
    });

    Object.keys(counts).forEach(function (roast) {
      const countEl = section.querySelector('[data-count="' + roast + '"]');
      if (countEl) {
        countEl.textContent = counts[roast];
      }
    });
  }

  /**
   * Set active tab styling
   */
  function setActiveTab(tabs, activeTab) {
    tabs.forEach(function (tab) {
      tab.classList.remove('active');
      tab.setAttribute('aria-selected', 'false');
    });
    activeTab.classList.add('active');
    activeTab.setAttribute('aria-selected', 'true');
  }

  /**
   * Filter products by roast level with animation
   */
  function filterProducts(products, roast, grid, emptyState) {
    var visibleCount = 0;

    // Phase 1: Hide non-matching products
    products.forEach(function (product) {
      var productRoast = product.getAttribute('data-roast');
      var shouldShow = roast === 'all' || productRoast === roast;

      if (!shouldShow && !product.classList.contains('hidden')) {
        product.classList.add('hiding');
      }
    });

    // Phase 2: After hide animation, show matching products
    setTimeout(function () {
      products.forEach(function (product) {
        var productRoast = product.getAttribute('data-roast');
        var shouldShow = roast === 'all' || productRoast === roast;

        product.classList.remove('hiding', 'showing');

        if (shouldShow) {
          product.classList.remove('hidden');
          product.classList.add('showing');
          visibleCount++;
        } else {
          product.classList.add('hidden');
        }
      });

      // Show/hide empty state
      if (emptyState) {
        emptyState.style.display = visibleCount === 0 ? 'block' : 'none';
      }
      if (grid) {
        grid.style.display = visibleCount === 0 ? 'none' : '';
      }
    }, 300);
  }

  /**
   * Update the roast scale indicator
   */
  function updateScale(scaleFill, roast) {
    if (scaleFill) {
      scaleFill.setAttribute('data-active-roast', roast);
    }
  }

  /**
   * Initialize Add to Cart functionality
   */
  function initAddToCart(section) {
    section.addEventListener('click', function (e) {
      var btn = e.target.closest('.adira-roast__add-btn');
      if (!btn || btn.disabled) return;

      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;

      var originalText = btn.textContent.trim();
      btn.textContent = 'Adding...';
      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: parseInt(variantId), quantity: 1 }],
        }),
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Add to cart failed');
          return response.json();
        })
        .then(function () {
          btn.textContent = '✓ Added!';
          btn.classList.add('added');

          setTimeout(function () {
            btn.textContent = originalText;
            btn.disabled = false;
            btn.classList.remove('added');
          }, 2000);

          // Update header cart icon bubble + open cart drawer
          notifyCartUpdate();
        })
        .catch(function (error) {
          console.error('Add to cart error:', error);
          btn.textContent = originalText;
          btn.disabled = false;
        });
    });
  }

  /**
   * Notify the theme's cart icon + cart drawer about the update.
   * Dispatches the standard 'cart:update' event with the proper detail
   * structure so the <cart-icon> bubble animates, then explicitly opens
   * the cart drawer. Falls back to /cart redirect if no drawer exists.
   */
  function notifyCartUpdate() {
    fetch('/cart.js')
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        // Theme event — same contract as CartAddEvent in events.js
        document.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              data: {
                itemCount: cart.item_count,
                source: 'shop-by-roast'
              }
            }
          })
        );

        // Open cart drawer directly (don't rely on auto-open setting)
        var cartDrawer = document.querySelector('cart-drawer-component');
        if (cartDrawer) {
          if (typeof cartDrawer.open === 'function') {
            cartDrawer.open();
          } else if (typeof cartDrawer.showDialog === 'function') {
            cartDrawer.showDialog();
          } else {
            window.location.href = '/cart';
          }
        } else {
          // No cart drawer in the DOM — redirect to cart page
          window.location.href = '/cart';
        }
      })
      .catch(function () {
        // Network error — redirect to cart as fallback
        window.location.href = '/cart';
      });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-initialize on Shopify Theme Editor section load
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target.querySelector(SECTION_SELECTOR)) {
        init(e.target);
      }
    });
  }
})();
